import { useMemo } from "react";
import { Outlet } from "react-router";

import Layout from "@src/@core/layouts/VerticalLayout";
import navigation from "@src/navigation/vertical";
import PermissionRouteGuard from "@src/utility/permissions/PermissionRouteGuard";
import { filterNavMenuByPermission } from "@src/utility/permissions/filterNavMenu";
import { useCheckPermission } from "@src/utility/permissions/useCheckPermission";

const VerticalLayout = (props: any) => {
  const { checkPermission } = useCheckPermission();

  const menuData = useMemo(
    () => filterNavMenuByPermission(navigation, checkPermission),
    [checkPermission]
  );

  return (
    <Layout menuData={menuData} {...props}>
      <PermissionRouteGuard />
      <Outlet />
    </Layout>
  );
};

export default VerticalLayout;
